import {OFFER_CATEGORIES, OFFER_TEMPLATES, type Offer} from '@chekin/core';
import type {VelaStayOffers} from './types';

type StayOffer = Pick<Offer, 'id' | 'category' | 'template'>;

const findOfferId = (
  offers: StayOffer[],
  category: OFFER_CATEGORIES,
  template: OFFER_TEMPLATES,
) =>
  offers.find(offer => offer.category === category || offer.template === template)?.id ??
  null;

export function getStayOffers(offers: StayOffer[] = []): VelaStayOffers {
  return {
    earlyCheckInId: findOfferId(
      offers,
      OFFER_CATEGORIES.checkIn,
      OFFER_TEMPLATES.checkIn,
    ),
    lateCheckOutId: findOfferId(
      offers,
      OFFER_CATEGORIES.checkOut,
      OFFER_TEMPLATES.checkOut,
    ),
  };
}
